<template>
  <v-row style="border: 1px solid gray; margin-bottom: 30px">
    <v-col cols="12">
      <div>
        <h1>Test OmiPay Transactions</h1>
        <h3 class="mb-4">
          Specify the number of months to test OmiPay transactions for.
        </h3>
        <v-text-field
          v-model.number="months"
          type="number"
          label="Number of months to test"
          min="1"
          :error-messages="errors"
          outlined
          dense
          :disabled="loading"
          class="mb-4"
        />
      </div>
      <v-btn
        rounded
        depressed
        :loading="loading"
        color="primary"
        @click="submit"
      >
        <span>Test OmiPay Transactions</span>
      </v-btn>
    </v-col>

    <ErrorSnackbar v-model="showError" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </v-row>
</template>

<script>
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import SuccessSnackbar from '../common/SuccessSnackbar.vue';
  import gql from 'graphql-tag';

  const TEST_OMIPAY_MUTATION = gql`
    mutation testOmipay($months: Int!) {
      testOmipay(months: $months) {
        success
      }
    }
  `;

  export default {
    name: 'TestOmiPay',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
    },
    mixins: [formHelperMixin],
    data() {
      return {
        months: 1,
        errors: [],
        showSuccess: false,
        successMessage: null,
      };
    },
    methods: {
      submit() {
        if (!this.months || this.months < 1) {
          this.errors = ['Please enter a valid number of months'];
          return;
        }

        this.errors = [];
        this.buttonLoading = true;

        this.$apollo
          .mutate({
            mutation: TEST_OMIPAY_MUTATION,
            variables: {
              months: this.months,
            },
          })
          .then(() => {
            this.successMessage = 'OmiPay test initiated successfully';
            this.showSuccess = true;
            this.buttonLoading = false;
          })
          .catch(error => {
            this.displayError();
            this.buttonLoading = false;
            throw error;
          });
      },
    },
  };
</script>

<style scoped>
  .v-card {
    border: 1px solid rgba(0, 0, 0, 0.12) !important;
  }
</style>
